import { useContext } from "react";
import { useSelector } from "react-redux";
import { Identifiable, Zone } from "@planzone/dto";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  transferProjects(request: Boundaries["transferProjects"]["request"]): void;
}

function useProjectsTransfer(destination: Identifiable<Zone>): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isProjectsTransferRequestPending(destination),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isProjectsTransferRequestSuccess(destination),
    ),
    isRequestFailure: useSelector(() =>
      selector.isProjectsTransferRequestFailure(destination),
    ),
    transferProjects: core.transferProjects,
  };
}

export { useProjectsTransfer };
